<template>
    <div class="wrap">
        <div class="head-box">
            <el-button type="primary" @click="addPlan" v-if="isMain || !isUnified">新增方案</el-button>
        </div>
        <div class="table-box">
            <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" header-cell-class-name="table-ceil">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column label="员工">
                    <template slot-scope="data">
                        <el-tag v-for="staff in data.row.staff_list" :key="staff.staff_id" effect="plain" type="warning" class="staff-item">
                            {{staff.staff_name}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="create_datetime" width="200" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="200" align="right">
                    <template slot-scope="data">
                        <el-button
                                size="mini"
                                @click="handleEdit(data.$index, data.row)"
                        >编辑</el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(data.$index, data.row)"
                                v-if="isMain || !isUnified"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-box">
            <el-pagination
                    @size-change="pageSizeChange"
                    @current-change="pageCurrentChange"
                    :current-page="page.nowPage"
                    :page-sizes="page.pageSizes"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.count">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "StaffRewardTableList",
        props: {
            pro_type: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            tableData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function () {
            this.init();
        },
        methods: {
            //初始化
            init: function () {
                this.page.nowPage = 1;
                this.page.count = 0;
                this.tableData = [];
                this.loadListData();
            },
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //添加按钮点击
            ,addPlan: function () {
                this.$root.go("system/staff_reward_option?pro_type="+this.pro_type);
            }

            //搜索
            ,searchEvent: function () {

            }

            //编辑
            ,handleEdit: function (index, data) {
                this.$root.go("system/staff_reward_option?pro_type="+this.pro_type+"&id="+data.id);
            }

            //删除
            ,handleDelete: function (index, data) {
                obj.messageBox.confirm("你确定要删除提成方案[ "+ data.name +" ]吗？", "警告", {
                    confirmButtonText: '确认删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    obj.postData("store_reward/delete_reward_option", {id: data.id}, function (res) {
                        if(res.errcode === 0){
                            this.loadListData();
                            obj.message.success("删除成功");
                        } else {
                            obj.message.error("删除失败");
                        }
                    }.bind(this));

                } ).catch( () => {
                    return false;
                });
            }

            //加载数据列表
            ,loadListData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    pro_type: this.pro_type
                };
                obj.postData("store_reward/get_reward_list", postData, res => {
                    if(res.errcode === 0) {
                        this.tableData = res.data;
                        this.page.count = res.count;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            }
        },
        watch: {
            pro_type: function (val) {
                this.init();
            }
        }
    }
</script>

<style scoped>
    .head-box{
        margin-bottom: 16px;
    }
    .staff-item{
        margin-right: 10px;
    }
</style>
